import {Component, EventEmitter, Input, OnInit, Output, inject} from '@angular/core';
import {DialogModule, TooltipModule} from "@syncfusion/ej2-angular-popups";
import {FormInputComponent} from "../../../shared/elements/form-input/form-input.component";
import {HeadlineComponent} from "../../../shared/elements/headline/headline.component";

import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {TYPE} from "../../../shared/types/types";
import {DialogService} from "../../../shared/services/dialog.service";
import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ItemDocumentsPreviewAvailableComponent} from "../item-documents-preview-available/item-documents-preview-available.component";

@Component({
    selector: 'app-dialog-documents-attachments',
    imports: [
        DialogModule,
        FormInputComponent,
        HeadlineComponent,
        TooltipModule,
        TranslatePipe,
        TooltipComponent,
        ItemDocumentsPreviewAvailableComponent
    ],
    templateUrl: './dialog-documents-attachments.component.html',
    styleUrl: './dialog-documents-attachments.component.scss'
})
export class DialogDocumentsAttachmentsComponent implements OnInit {
  public dialogService: DialogService = inject(DialogService);
  private formBuilder: FormBuilder = inject(FormBuilder);

  @Input() public files: TYPE.Document[] = [];
  @Input() public visible: boolean = false;
  @Output() public  visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public documentsAttachmentsForm: FormGroup = this.formBuilder.group({
    searchString: [''],
  });
  public filesFiltered: TYPE.Document[] = [];

  public ngOnInit(): void {
    this.filesFiltered = this.files;
    this.documentsAttachmentsForm.controls['searchString'].valueChanges.subscribe((value: string) => {
      this.filesFiltered = this.files.filter((file: TYPE.Document) => {
        return file.filename!.toLowerCase().includes(value.toLowerCase());
      });
    });
  }

  public resetSearch(): void {
    this.documentsAttachmentsForm.controls['searchString'].setValue('');
  }

  public close(): void {
    this.visibleChange.emit(false);
  }

}
